import { stringify } from 'qs';
import SuperFetchV2 from '../../superFetchV2';
import {
  BatchDetailResponse,
  EligibleItemsQuery,
  EligibleItemsResponse,
  ExecuteRequest,
  ExecuteResponse,
  ItemHistoryResponse,
  ListBatchesQuery,
  ListBatchesResponse,
  PreviewRequest,
  PreviewResponse,
  RollbackRequest,
  RollbackResponse,
  VerifyResponse,
} from './types';

const BASE = '/settlement-date-adjustments';

/**
 * 정산 기준일 변경 API 클라이언트.
 * 백엔드 apps/admin/src/settlement/settlement-date-adjustments 와 1:1 대응.
 */
export const settlementDateAdjustmentApi = {
  getEligibleItems: (params: EligibleItemsQuery): Promise<EligibleItemsResponse> =>
    SuperFetchV2.get(`${BASE}/eligible-items`, {
      params,
      paramsSerializer: (p) => stringify(p, { arrayFormat: 'comma' }),
    }),

  preview: (body: PreviewRequest): Promise<PreviewResponse> =>
    // @ts-expect-error SuperFetchV2 인터셉터 타입 이슈 (기존 settlementApi 와 동일 패턴)
    SuperFetchV2.post<Promise<PreviewResponse>>(`${BASE}/preview`, body),

  execute: (body: ExecuteRequest): Promise<ExecuteResponse> =>
    // @ts-expect-error SuperFetchV2 인터셉터 타입 이슈
    SuperFetchV2.post<Promise<ExecuteResponse>>(`${BASE}/execute`, body),

  listBatches: (params: ListBatchesQuery): Promise<ListBatchesResponse> =>
    SuperFetchV2.get(`${BASE}/batches`, {
      params,
      paramsSerializer: (p) => stringify(p, { arrayFormat: 'comma' }),
    }),

  getBatchDetail: (batchId: string): Promise<BatchDetailResponse> =>
    SuperFetchV2.get(`${BASE}/batches/${batchId}`),

  rollback: (batchId: string, body: RollbackRequest): Promise<RollbackResponse> =>
    // @ts-expect-error SuperFetchV2 인터셉터 타입 이슈
    SuperFetchV2.post<Promise<RollbackResponse>>(`${BASE}/batches/${batchId}/rollback`, body),

  verify: (batchId: string): Promise<VerifyResponse> =>
    SuperFetchV2.get(`${BASE}/batches/${batchId}/verify`),

  getItemHistory: (settlementItemId: number): Promise<ItemHistoryResponse> =>
    SuperFetchV2.get(`${BASE}/items/${settlementItemId}/history`),
};
